import styled from 'styled-components';


export const StyledSVGWrapper = styled.div`
  position: relative;
  border-radius: 6px;
  width: 100%;
  padding-top: 100%;
  //background-image: url("/grain.webp");
  background-repeat: repeat;
  background-size: 256px;
`;

export const StyledSVG = styled.img`
  border-radius: 6px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  height: auto;
  transition: opacity .15s ease-in; 
`

